import { customToolbar } from '@src/main/shared/ui/components/input/customToolbar';
import DOMPurify from 'dompurify';
import { Editor } from 'primereact/editor';
import { FC } from 'react';

interface EditorFieldProps {
  label?: string;
  value: string;
  onChange: (val: string) => void;
  error?: string;
  styles: Record<string, string>;
  setPlainText?: (val: string) => void;
}

const normalizeLists = (html: string) =>
  html
    .replace(/<ol><li data-list="bullet">/g, '<ul><li>')
    .replace(/<li data-list="ordered">/g, '<li>')
    .replace(/<\/li><\/ol>/g, '</li></ol>')
    .replace(/<\/li><\/ul>/g, '</li></ul>');

export const EditorField: FC<EditorFieldProps> = ({
  label,
  value,
  onChange,
  error,
  styles,
  setPlainText,
}) => (
  <div className={`${styles['form-section']} ${styles['textarea-section']}`}>
    <Editor
      value={value}
      onTextChange={(e) => {
        const htmlValue = e.htmlValue ?? '';
        const sanitizedHtml = DOMPurify.sanitize(htmlValue, {
          ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li'],
          ALLOWED_ATTR: [],
        });
        const normalizedHtml = normalizeLists(sanitizedHtml);
        const textValue = normalizedHtml
          .replace(/<\/p>|<br\s*\/?>/gi, '\n')
          .replace(/<li>/gi, '• ')
          .replace(/<\/li>/gi, '\n')
          .replace(/<\/?[^>]+(>|$)/g, '');

        onChange(normalizedHtml);
        setPlainText?.(textValue);
      }}
      style={{ height: '320px' }}
      placeholder={label}
      className={error ? 'p-invalid' : ''}
      headerTemplate={customToolbar}
    />

    {error && <small className="p-error">{error}</small>}
  </div>
);
